<template>
  <div class="Notification-fallback">
    <div class="Notification-fallbackGraphic">
      <svg>
        <use xlink:href="#Company" />
      </svg>
    </div>
    <h3>You have no company notifications</h3>
    <p>Recently saved companies and alerts will appear here.</p>
    <img
      :src="image"
      alt="no companies"
    >
    <p>Click on the thumb icon next to a company to save it. You will be reminded when job deadlines are approaching.</p>
  </div>
</template>
<script>
import ThumbSearchHint from '../images/thumb-search-hint.png';

export default {
  data() {
    return {
      image: ThumbSearchHint,
    };
  },
};
</script>
